const req = require.context('./svg', true, /\.svg$/)

req.keys().forEach(req)

export default {
  getNameList() {
    return req.keys().map(item => {
      const match = item.match(/\.\/(.*)\.svg/)
      return match ? match[1] : ''
    })
  }
}